import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcFace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 20.467a8.5 8.5 0 1 0-9.217-9.217c-.036.413-.369.75-.783.75s-.753-.337-.722-.75C2.41 6.077 6.729 2 12 2c5.523 0 10 4.477 10 10 0 5.27-4.077 9.589-9.25 9.972-.413.03-.75-.308-.75-.722s.337-.747.75-.783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.465 15.686A2.343 2.343 0 1 0 2.151 19l3.314 3.314L8.78 19a2.343 2.343 0 0 0-3.314-3.314m0 4.507L3.212 17.94a.844.844 0 0 1 1.192-1.193l1.06 1.06 1.062-1.06a.843.843 0 0 1 1.192 1.192z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.01 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.67 13.69a.75.75 0 0 1-.303 1.017c-.848.457-1.562.734-2.32.72-.748-.015-1.429-.313-2.196-.716a.75.75 0 0 1 .696-1.328c.752.394 1.16.537 1.529.544.36.006.791-.116 1.578-.54a.75.75 0 0 1 1.016.303",
    clipRule: "evenodd"
  }));
}
var IcFace = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFace));

export { IcFace as I };
